import { API } from '@constants';
import apiAxios from '@services/axios';
import { ResponseError } from '@types';
import { Spinner } from '@uikit';
import { createContext, Dispatch, useEffect, useMemo, useReducer } from 'react';
import { auth } from '../../utils';
import reducer from './reducer';
import { ActionTypes, AuthState, InitializeAction } from './types';

type AuthProviderProps = {
  children: React.ReactNode;
};

const initialAuthState: AuthState = {
  isAuthenticated: false,
  isInitialized: false
};

export const AuthContext = createContext<{
  state: AuthState;
  dispatch: Dispatch<InitializeAction>;
}>({
  state: initialAuthState,
  dispatch: () => {}
});

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialAuthState);

  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  const initializeAuth = () => {
    apiAxios
      .get(API.AUTH)
      .then(() => {
        dispatch({
          type: ActionTypes.INITIALIZE,
          payload: true
        });
      })
      .catch((err: ResponseError) => {
        if (err.status === 404) {
          auth.login();
        }
        dispatch({
          type: ActionTypes.INITIALIZE,
          payload: false
        });
      });
  };

  useEffect(() => {
    initializeAuth();
  }, []);

  if (!state.isInitialized || !state.isAuthenticated) {
    return <Spinner hideOverlay />;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
